import React from 'react';
import PropTypes from 'prop-types';

import Button from 'react-toolbox/lib/button/Button';
import ProgressBar from 'react-toolbox/lib/progress_bar/ProgressBar';

import {FormRow, Picture, Striped, ThemedHeader, TwoColumnRow} from '../../Styled';
import Registration from "../containers/Registration";

import picture from '../../../images/tandem/top.jpg'

const Tandems = ({isFilled, submit, submitWaiting, submitSuccess, submitFailure}) => {
    return (
        <React.Fragment>
            <Striped>
                <TwoColumnRow>
                        <span>
                            <ThemedHeader>Fly with us!</ThemedHeader>
                            <p>Don't know how to fly? No problem! We'll take you up for an unforgettable experience of non-powered flight. Beware - we will not be responsible if you decide to become a pilot and spend all you free time in the air!</p>
                        </span>
                    <Picture src={picture}/>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <TwoColumnRow className='mobile-row-2'>
                    <div style={{
                        position:      'relative',
                        width:         '100%',
                        height:        '0px',
                        paddingBottom: '58%'
                    }}>
                        <iframe title='Live With Casey - Paragliding Utah' frameBorder={0} allowFullScreen={true}
                                style={{
                                    border:   0,
                                    position: 'absolute',
                                    left:     0,
                                    top:      0,
                                    width:    '100%',
                                    height:   '100%'
                                }}
                                src='//kutv.com/embed/news/2news-this-morning/live-with-casey-paragliding-utah'/>
                    </div>
                    <ThemedHeader className='mobile-row-1'>What is it like?</ThemedHeader>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <TwoColumnRow>
                    <ThemedHeader>Fun For Everybody!</ThemedHeader>
                    <span>
                            <p>Tandem flight can be enjoyed by anyone under 260 pounds of any age with no prior experience necessary. Minors need to be accompanied by an adult.</p>
                            <p>We use a larger canopy designed to carry two people. Each person has their own harness, and the passenger and instructor fly together. The Tandem instructor sits in the back and the passenger sits in front, where the view is best! We organize all the equipment and do a simulation before our actual launch, so you can sit back and enjoy the experience.</p>
                            <p>When we’re ready we’ll run a few steps together and before you know it we’ll be airborne! The flight will last at least twenty minutes, possibly more depending on the conditions and your karma.</p>
                            <p>Since the passenger is flying in the front, in addition to a great view you are exposed to the wind. It may get quite cold where we fly, even though the temperature is quite warm. Be sure to come prepared by bringing multiple layers. Your instructor can brief you on the expected temperature at altitude before your flight.</p>
                        </span>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <TwoColumnRow>
                    <div className='mobile-row-2'>
                        <span>We are available seven days a week if you schedule in advance. Reach us at 801.707.0508 to see if we have a last minute opening. Flying is weather dependent, so when the conditions are good we look forward to flying with you!</span>
                        <ul>
                            <li>Protective footwear, no open toe shoes</li>
                            <li>Pants, jeans are great</li>
                            <li>Warm clothing layers and a Jacket</li>
                            <li>Warm gloves</li>
                            <li>Sun Glasses, sunblock</li>
                            <li>You may bring a compact camera if you wish</li>
                        </ul>
                    </div>
                    <ThemedHeader className='mobile-row-1'>Recommended clothing</ThemedHeader>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <FormRow>
                    <ThemedHeader>Sign up!</ThemedHeader>
                    <span style={{minWidth: "100%"}}>
                            <Registration/>

                        {!submitWaiting && !submitSuccess && !submitFailure &&
                         <Button icon='payment' label='Pay with Card' raised primary disabled={!isFilled}
                                 onClick={submit}/>}

                        {submitWaiting && <ProgressBar type="circular" mode="indeterminate"/>}

                        {submitSuccess &&
                         <div style={{color: 'green'}}>
                             <strong>Your card has been charged. Thank you!</strong>
                         </div>}

                        {submitFailure &&
                         <div style={{color: 'red'}}>
                             <strong>Something went wrong! Please let us know and try again later.</strong>
                         </div>}
                    </span>
                </FormRow>
            </Striped>
        </React.Fragment>
    )
};

Tandems.propTypes = {
    isFilled:      PropTypes.bool.isRequired,
    submit:        PropTypes.func.isRequired,
    submitWaiting: PropTypes.bool.isRequired,
    submitSuccess: PropTypes.bool.isRequired,
    submitFailure: PropTypes.bool.isRequired
};

export default Tandems;



// WEBPACK FOOTER //
// ./src/app/tandems/components/Tandems.js